export class SupplierThemeDto {
    primaryColor : string;
    borderRadius : number;
    isDarkMode : boolean;
    supplierId : number
}